$('.colorbox-inline').colorbox({
	title: false,
	inline: true,
	fixed: true,
	maxWidth: '97%',
	maxHeight: '97%',
	current: false,
	previous: false,
	next: false,
	close: '<span class="icon icon-close"></span>'
});

$('.colorbox').colorbox({
	rel: 'gal',
	fixed: true,
	maxWidth: '95%',
	maxHeight: '95%',
	current: false,
	previous: false,
	next: false,
	close: '<span class="icon icon-close"></span>'
});

$('.colorbox-close').click(function () {
	parent.$.colorbox.close();
	return false;
});




// WEBPACK FOOTER //
// ./_dev/blocks/colorbox/colorbox.js